import React from "react"

export const ColumnList = ({children}) => (
  <ul className="columns-2-l column-gap-6-l">
    {children}
  </ul>
)
